// Tiny namespaced preference store for NON-SENSITIVE UI state only (mute flag,
// last selected bet, etc.). It NEVER stores tokens, balances, or any
// server-authoritative data. Backed by localStorage with a safe in-memory
// fallback so it works in sandboxed iframes and tests.
function memoryStorage() {
    const m = new Map();
    return {
        getItem: (k) => (m.has(k) ? m.get(k) : null),
        setItem: (k, v) => void m.set(k, v),
        removeItem: (k) => void m.delete(k),
    };
}
function resolveStorage() {
    try {
        if (typeof localStorage !== 'undefined') {
            const probe = '__gs_probe__';
            localStorage.setItem(probe, '1');
            localStorage.removeItem(probe);
            return localStorage;
        }
    }
    catch {
        // Access can throw in privacy modes / sandboxed iframes.
    }
    return memoryStorage();
}
/**
 * Creates a namespaced preference store. Keys are prefixed with the namespace
 * so multiple game clients on the same origin never collide.
 */
export function createPreferences(namespace, storage = resolveStorage()) {
    const k = (key) => `${namespace}:${key}`;
    return {
        getBoolean(key, fallback) {
            try {
                const v = storage.getItem(k(key));
                return v === null ? fallback : v === '1' || v === 'true';
            }
            catch {
                return fallback;
            }
        },
        setBoolean(key, value) {
            try {
                storage.setItem(k(key), value ? '1' : '0');
            }
            catch {
                /* ignore */
            }
        },
        getInt(key, fallback) {
            try {
                const v = storage.getItem(k(key));
                if (v === null)
                    return fallback;
                const n = Number.parseInt(v, 10);
                return Number.isFinite(n) ? n : fallback;
            }
            catch {
                return fallback;
            }
        },
        setInt(key, value) {
            try {
                storage.setItem(k(key), String(Math.trunc(value)));
            }
            catch {
                /* ignore */
            }
        },
        getString(key, fallback = null) {
            try {
                const v = storage.getItem(k(key));
                return v === null ? fallback : v;
            }
            catch {
                return fallback;
            }
        },
        setString(key, value) {
            try {
                storage.setItem(k(key), value);
            }
            catch {
                /* ignore */
            }
        },
        remove(key) {
            try {
                storage.removeItem(k(key));
            }
            catch {
                /* ignore */
            }
        },
    };
}
//# sourceMappingURL=preferences.js.map